import { render, staticRenderFns } from "./SvgIcon.vue.js?vue&type=template&id=2929c782&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SvgIcon.vue?vue&type=template&id=2929c782&scoped=true"
import script from "./SvgIcon.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SvgIcon.vue?vue&type=script&lang=js"
import style0 from "./SvgIcon.vue.css?vue&type=style&index=0&id=2929c782&prod&scoped=true&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SvgIcon.vue?vue&type=style&index=0&id=2929c782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2929c782",
  null
  
)

export default component.exports